'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { useRouter } from 'next/navigation';
import { myCruzApi } from '@/api';
import { Button, Container, CruzIcon, Divider, SignInWithApple, SignInWithEmail, SignInWithFacebook, SignInWithGoogle } from '@/components';
import { pages } from '@/settings';
import { useGlobalStore } from '@/store/provider';
export function ModalSignIn(t0) {
  const $ = _c(40);
  const {
    hideSocialSignin
  } = t0;
  const {
    user,
    setUser,
    modalSignIn,
    setModalSignIn
  } = useGlobalStore(_temp);
  const router = useRouter();
  let t1;
  if ($[0] !== modalSignIn || $[1] !== setModalSignIn || $[2] !== setUser || $[3] !== user) {
    t1 = async function afterSignIn() {
      const {
        saveVehicleId,
        like,
        saveSearch
      } = modalSignIn || {};
      if (saveSearch) {
        setModalSignIn({
          show: false,
          saveSearch
        });
        return;
      }
      setModalSignIn({
        show: false
      });
      if (saveVehicleId) {
        const {
          data
        } = await myCruzApi.saveVehicle.toggleSave(saveVehicleId);
        setUser({
          ...user,
          ...data
        }, null);
      }
      if (like) {
        const {
          name,
          id
        } = like;
        await myCruzApi.toggleLike({
          name,
          id
        });
      }
    };
    $[0] = modalSignIn;
    $[1] = setModalSignIn;
    $[2] = setUser;
    $[3] = user;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const afterSignIn = t1;
  let t2;
  if ($[5] !== router || $[6] !== setModalSignIn) {
    t2 = function gotoJoinCruz() {
      setModalSignIn({
        show: false
      });
      router.push(pages.joinCruz.href);
    };
    $[5] = router;
    $[6] = setModalSignIn;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const gotoJoinCruz = t2;
  let t3;
  if ($[8] !== router || $[9] !== setModalSignIn) {
    t3 = function gotoForgotPassword() {
      setModalSignIn({
        show: false
      });
      router.push(pages.forgotPassword.href);
    };
    $[8] = router;
    $[9] = setModalSignIn;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const gotoForgotPassword = t3;
  let t4;
  if ($[11] !== setModalSignIn) {
    t4 = function handleClose() {
      setModalSignIn({
        show: false
      });
    };
    $[11] = setModalSignIn;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleClose = t4;
  const t5 = modalSignIn?.show || false;
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DialogBackdrop className="dialog-backdrop" />;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h2>Sign in<div className="h2-line-red" /></h2>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CruzIcon.Close className="size-6" />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== handleClose) {
    t9 = <div className="mb-2 flex items-start justify-between">{t7}<Button type="button" variant="transparent" className="h-12 rounded-full" onClick={handleClose}>{t8}</Button></div>;
    $[16] = handleClose;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== afterSignIn) {
    t10 = <SignInWithEmail afterSignInAction={afterSignIn} />;
    $[18] = afterSignIn;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== gotoForgotPassword) {
    t11 = <Button type="button" variant="outline" onClick={gotoForgotPassword} className="btn-signin">{pages.forgotPassword.name}</Button>;
    $[20] = gotoForgotPassword;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span>Join Cruz<sup className="text-[7px]">TM</sup> with Email</span>;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== gotoJoinCruz) {
    t13 = <Button type="button" variant="outline" className="btn-signin" onClick={gotoJoinCruz}>{t12}</Button>;
    $[23] = gotoJoinCruz;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t13) {
    t14 = <div className="space-y-3 text-center">{t11}{t13}</div>;
    $[25] = t11;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== afterSignIn || $[29] !== hideSocialSignin) {
    t15 = !hideSocialSignin && <><Divider label="or" className="my-5" /><div className="mb-4 space-y-3"><SignInWithGoogle afterSignInAction={afterSignIn} /><SignInWithApple afterSignInAction={afterSignIn} /><SignInWithFacebook afterSignInAction={afterSignIn} /></div></>;
    $[28] = afterSignIn;
    $[29] = hideSocialSignin;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t10 || $[32] !== t14 || $[33] !== t15 || $[34] !== t9) {
    t16 = <Container size="xs" className="fixed inset-0 z-20 flex items-center justify-center"><DialogPanel className="dialog-panel">{t9}{t10}{t14}{t15}</DialogPanel></Container>;
    $[31] = t10;
    $[32] = t14;
    $[33] = t15;
    $[34] = t9;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== handleClose || $[37] !== t16 || $[38] !== t5) {
    t17 = <Dialog autoFocus={false} open={t5} onClose={handleClose} className="relative z-40">{t6}{t16}</Dialog>;
    $[36] = handleClose;
    $[37] = t16;
    $[38] = t5;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
}
function _temp(state) {
  return state;
}